import { Avatar, InputAdornment, TextField, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { ChangeEvent, useMemo, Dispatch, SetStateAction } from 'react';
import { COMMON_STRING } from '@/constants/dictionary';
import { ComparisonBox } from '../ComparisonRating/common';
import { TEXT_FIELD_CONSTANCE } from '../ActionEvaluationDialog/constants';
import { TextFieldCharactersCounter } from '../common/TextFieldCharactersCounter';
import { EvaluationTypes, PLACEHOLDER_FEEDBACK } from './constants';

export interface EvaluationProps {
  evaluation: EvaluationTypes;
  setEvaluation: Dispatch<SetStateAction<EvaluationTypes>>;
}

export const SupervisorEvaluationComment = ({
  evaluation,
  setEvaluation,
}: EvaluationProps) => {
  const { authState } = useOktaAuth();

  const username = authState?.idToken?.claims.name ?? '';

  const userInitials = useMemo(() => {
    if (!username) return;
    const [[first], [second]] = username.split(' ');
    return first + second;
  }, [username]);

  const handleCommentChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT) {
      setEvaluation({ ...evaluation, feedbackText: event.target.value });
    }
  };

  return (
    <ComparisonBox gap={2} textTransform='uppercase'>
      <Typography>{COMMON_STRING.ADD_FEEDBACK}</Typography>
      <TextField
        id='supervisor-evaluation-feedback'
        multiline
        value={evaluation.feedbackText}
        onChange={handleCommentChange}
        placeholder={PLACEHOLDER_FEEDBACK}
        minRows={6}
        maxRows={16}
        required
        inputProps={{
          maxLength: TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT,
        }}
        InputProps={{
          style: { padding: '1rem 0.875rem 1rem 2.25rem' },
          startAdornment: (
            <InputAdornment position='start'>
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  fontSize: '0.75rem',
                  position: 'absolute',
                  top: (theme) => theme.spacing(2),
                  left: (theme) => theme.spacing(1.5),
                }}
              >
                {userInitials}
              </Avatar>
            </InputAdornment>
          ),
        }}
      />
      <TextFieldCharactersCounter text={evaluation.feedbackText} />
    </ComparisonBox>
  );
};
